import script from "./defaultLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./defaultLayout.vue?vue&type=script&setup=true&lang=js"

import "./defaultLayout.vue?vue&type=style&index=0&id=aac156a0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aac156a0"]])

export default __exports__